function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStadium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 576 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M560.589,297.563l0,110.836c0,47.105 -124.533,83.126 -276.74,83.126c-38.744,0 -77.487,-2.771 -110.696,-8.312l-0,-74.814l-110.697,-27.709l0,77.585c-35.976,-13.855 -55.348,-30.48 -55.348,-49.876l0,-166.253c0,-27.709 55.348,-55.418 110.697,-55.418c166.044,-0 221.392,152.399 359.762,152.399c55.348,-0 83.022,-41.564 83.022,-41.564m-470.458,-152.398l110.696,27.708l-0,-83.126l-110.696,-27.709l-0,83.127Zm359.762,-41.564l110.696,27.709l0,-83.126l-110.696,-27.709l0,83.126Zm118.999,119.148c-0,-27.708 -22.14,-77.584 -99.627,-77.584c-77.487,-0 -146.672,74.813 -149.44,80.355c49.813,36.022 88.557,72.043 157.742,72.043c91.325,0 91.325,-74.814 91.325,-74.814Z",
    style: {
      fill: "none",
      fillRule: "nonzero",
      stroke: "#000",
      strokeWidth: "12.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.582,310.663l0.113,-13.19",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: "12.3px",
      strokeLinecap: "round",
      strokeMiterlimit: 1.5
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStadium);
export default __webpack_public_path__ + "static/media/stadium.167767459da2ca4db74c0f16bdbc3a08.svg";
export { ForwardRef as ReactComponent };